import { render, staticRenderFns } from "./LightboxGallery.vue?vue&type=template&id=9cfac874&scoped=true&"
import script from "./LightboxGallery.vue?vue&type=script&lang=js&"
export * from "./LightboxGallery.vue?vue&type=script&lang=js&"
import style0 from "./LightboxGallery.vue?vue&type=style&index=0&id=9cfac874&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfac874",
  null
  
)

export default component.exports